import { createContext } from "react";

export const LangContext = createContext(null);
export const CurrentLangContext = createContext(null);